/******/ (() => { // webpackBootstrap
class GalleryImage extends HTMLElement {
  constructor() {
    super();
    this.modal = document.getElementById(`PopupModal-${this.id}`);
    this.images = window.galleryImages[this.id] || [];
    this.index = 0;
    this.imageZoom = this.imageZoom.bind(this);
    this.getCursorPos = this.getCursorPos.bind(this);
    this.moveLens = this.moveLens.bind(this);
  }
  getCursorPos(e) {
    var a, x = 0, y = 0;
    e = e || window.event;
    a = this.img.getBoundingClientRect();
    x = e.pageX - a.left;
    y = e.pageY - a.top;
    x = x - window.pageXOffset;
    y = y - window.pageYOffset;
    return { x, y };
  }
  moveLens(e) {
    var pos, x, y;
    e.preventDefault();
    pos = this.getCursorPos(e);
    x = pos.x - this.lens.offsetWidth / 2;
    y = pos.y - this.lens.offsetHeight / 2;
    if (x > this.img.offsetWidth - this.lens.offsetWidth) {
      x = this.img.offsetWidth - this.lens.offsetWidth;
    }
    if (x < 0) {
      x = 0;
    }
    if (y > this.img.offsetHeight - this.lens.offsetHeight) {
      y = this.img.offsetHeight - this.lens.offsetHeight;
    }
    if (y < 0) {
      y = 0;
    }
    this.lens.style.left = x + "px";
    this.lens.style.top = y + "px";
    this.result.style.backgroundPosition = "-" + x * this.cx + "px -" + y * this.cy + "px";
    this.result.style.backgroundPosition = -1 * x / this.img.offsetWidth * this.img.width + "px " + -1 * y / this.img.offsetHeight * this.img.height + "px";
  }
  imageZoom(id) {
    const imgID = `img-${id}`;
    const resultID = `zoom-${id}`;
    var img, lens, result, cx, cy;
    img = document.getElementById(imgID);
    result = document.getElementById(resultID);
    lens = img.querySelector(".img-zoom-lens");
    img.width = img.dataset.width;
    img.height = img.dataset.height;
    cx = img.width / img.offsetWidth;
    cy = img.height / img.offsetHeight;
    result.style.backgroundImage = `url(${img.dataset.src})`;
    result.style.backgroundSize = img.width + "px " + img.height + "px";
    lens.addEventListener("mousemove", this.moveLens);
    img.addEventListener("mousemove", this.moveLens);
    lens.addEventListener("touchmove", this.moveLens);
    img.addEventListener("touchmove", this.moveLens);
    this.img = img;
    this.lens = lens;
    this.result = result;
    this.cx = cx;
    this.cy = cy;
  }
  handleButtons() {
    this.navButtons = this.navButtons || Array.from(this.modal.getElementsByClassName("gallery-btn"));
    this.navButtons[0].disabled = this.index === 0;
    this.navButtons[1].disabled = this.index >= this.images.length - 1;
  }
  setModalHtml(index = 0) {
    this.modalBody = this.modalBody || this.modal.querySelector(".js-modal-body");
    if (!this.modalBody) return;
    this.index = parseInt(index);
    const data = this.images[this.index] || {};
    const html = data.html || "";
    this.modalBody.innerHTML = html;
    this.handleButtons();
    this.imageZoom(data.id);
  }
  addEvents() {
    this.addEventListener("click", (e) => {
      const btn = e.target.closest("modal-opener");
      if (btn) {
        this.setModalHtml(btn.dataset.index);
      }
    });
    this.modal.addEventListener("click", (e) => {
      const prevNext = e.target.closest(".gallery-btn");
      if (prevNext) {
        const newIndex = prevNext.name === "previous" ? this.index - 1 : this.index + 1;
        this.setModalHtml(newIndex);
      }
      const zoomIn = e.target.closest(".gallery-img-sm");
      if (zoomIn) {
        if (this.isZoomed) {
          this.modal.classList.remove("zoom-in");
        } else {
          this.modal.classList.add("zoom-in");
        }
        this.isZoomed = !this.isZoomed;
      }
    });
  }
  connectedCallback() {
    if (!this.modal) return;
    this.addEvents();
    this.setModalHtml();
  }
}
customElements.define("gallery-image", GalleryImage);

/******/ })()
;